import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2240490")

_pushScopeId("data-v-e2240490")
const _hoisted_1 = {
  key: 0,
  class: "form-simulation-works"
}
const _hoisted_2 = { class: "title-3" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "title-3" }
const _hoisted_6 = { class: "title-3" }
const _hoisted_7 = { class: "title-3" }
const _hoisted_8 = { class: "title-3" }
const _hoisted_9 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($setup.simulationForm)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("dig-ui-title", _hoisted_2, _toDisplayString($setup.t('works')), 1),
        _createVNode("dig-input-select-picker", {
          id: "name",
          value: $setup.simulationForm.name,
          onSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateField('name', $event.detail))),
          label: $setup.t('Simulation.works'),
          required: ""
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_WORKS, (works) => {
            return (_openBlock(), _createBlock("dig-input-select-picker-option", {
              key: works.type,
              value: `${works.type}`
            }, _toDisplayString($setup.t(`Simulation.WorksTypes.${works.type}`)), 9, ["value"]))
          }), 128))
        ], 40, ["value", "label"]),
        _createVNode("dig-input-number", {
          id: "count",
          value: $setup.simulationForm.count,
          onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateField('count', $event.target.value))),
          suffix: $setup.t(`Simulation.WorksUnits.${$setup.simulationForm.name}`),
          required: ""
        }, _toDisplayString($setup.t(`Simulation.WorksPrefix.${$setup.simulationForm.name}`)), 41, ["value", "suffix"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("dig-input-number", {
            id: "priceEquipmentPerCount",
            value: $setup.simulationForm.priceEquipmentPerCount,
            onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateField('priceEquipmentPerCount', $event.target.value))),
            suffix: "€ HT",
            required: ""
          }, _toDisplayString($setup.t('Simulation.priceEquipmentPerCount', {
            unit: $setup.t(`Simulation.WorksUnits.${$setup.simulationForm.name}`),
          })), 41, ["value"]),
          _createVNode("dig-input-number", {
            id: "priceEquipment",
            value: $setup.simulationForm.priceEquipment,
            onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateField('priceEquipment', $event.target.value))),
            suffix: "€ HT",
            required: ""
          }, _toDisplayString($setup.t('Simulation.priceEquipment')), 41, ["value"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("dig-input-number", {
            id: "priceWorkforcePerCount",
            value: $setup.simulationForm.priceWorkforcePerCount,
            onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateField('priceWorkforcePerCount', $event.target.value))),
            suffix: "€ HT",
            required: ""
          }, _toDisplayString($setup.t('Simulation.priceWorkforcePerCount', {
            unit: $setup.t(`Simulation.WorksUnits.${$setup.simulationForm.name}`),
          })), 41, ["value"]),
          _createVNode("dig-input-number", {
            id: "priceWorkforce",
            value: $setup.simulationForm.priceWorkforce,
            onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateField('priceWorkforce', $event.target.value))),
            suffix: "€ HT",
            required: ""
          }, _toDisplayString($setup.t('Simulation.priceWorkforce')), 41, ["value"])
        ]),
        _createVNode("dig-ui-title", _hoisted_5, _toDisplayString($setup.t('primesCee')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
          return (_openBlock(), _createBlock("div", { key: taxBracket }, [
            (
          !$setup.simulationForm.taxBracket || $setup.simulationForm.taxBracket === taxBracket
        )
              ? (_openBlock(), _createBlock("dig-input-number", {
                  key: 0,
                  id: "ceePrime",
                  value: $setup.simulationForm.cee[taxBracket],
                  suffix: "€",
                  onInput: ($event: any) => ($setup.updateCee(taxBracket, $event.target.value)),
                  hint: $setup.t(`Simulation.TaxBracket.${taxBracket}`)
                }, _toDisplayString($setup.t('Simulation.ceePrimeTax', { name: taxBracket })), 41, ["value", "onInput", "hint"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode("dig-input-text", {
          id: "ceeName",
          value: $setup.simulationForm.ceeName,
          onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateField('ceeName', $event.target.value)))
        }, _toDisplayString($setup.t('Simulation.ceeName')), 41, ["value"]),
        _createVNode("dig-ui-title", _hoisted_6, _toDisplayString($setup.t('maPrimeRenov')), 1),
        _createVNode("dig-input-checkbox", {
          id: "disable-renov",
          checked: $setup.simulationForm.disableRenov,
          onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateField('disableRenov', $event.detail)))
        }, _toDisplayString($setup.t('disableMaPrimeRenov')), 41, ["checked"]),
        (
        !$setup.simulationForm.disableRenov && $setup.simulationForm.name === $setup.WorkType.AUTRE
      )
          ? (_openBlock(), _createBlock("dig-input-number", {
              key: 0,
              id: "other",
              value: $setup.simulationForm.fixRenov,
              onInput: _cache[9] || (_cache[9] = ($event: any) => ($setup.updateField('fixRenov', $event.target.value))),
              suffix: "€"
            }, _toDisplayString($setup.t('Simulation.renov')), 41, ["value"]))
          : _createCommentVNode("", true),
        _createVNode("dig-ui-title", _hoisted_7, _toDisplayString($setup.t('primesOther')), 1),
        _createVNode("dig-input-number", {
          id: "other",
          value: $setup.simulationForm.otherPrime,
          onInput: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateField('otherPrime', $event.target.value))),
          suffix: "€"
        }, _toDisplayString($setup.t('Simulation.otherPrime')), 41, ["value"]),
        _createVNode("dig-input-text", {
          id: "otherName",
          value: $setup.simulationForm.otherName,
          onInput: _cache[11] || (_cache[11] = ($event: any) => ($setup.updateField('otherName', $event.target.value)))
        }, _toDisplayString($setup.t('Simulation.otherName')), 41, ["value"]),
        _createVNode("dig-ui-title", _hoisted_8, _toDisplayString($setup.t('detail')), 1),
        _createVNode("dig-input-textarea", {
          value: $setup.simulationForm.comment,
          onInput: _cache[12] || (_cache[12] = ($event: any) => ($setup.updateField('comment', $event.target.value))),
          maxlength: "250"
        }, _toDisplayString($setup.t('Simulation.comment')), 41, ["value"]),
        _createVNode("div", _hoisted_9, [
          _createVNode("dig-ui-standard-button", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.reset()))
          }, _toDisplayString($setup.t('reinit')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
})